import { createModule } from '../../createModule';
const scope = (params) => ({
    fund_name: params.fund_name,
    value_date: params.value_date,
});
export const createAccruedInterestsAPI = createModule(({ http }) => ({
    emailBalanceChart: (params) => http.post('/v2/accrued-interests/balances/chart/email', {
        body: { fund_name: params.fund_name, instrument_id: params.instrument_id, revision: params.revision },
    }),
    getChartInstruments: (params) => http.get('/v2/accrued-interests/balances/chart/instruments', {
        params: { fund_name: params.fund_name },
    }),
    getBalanceChart: (params) => http.get('/v2/accrued-interests/balances/chart', {
        params: { fund_name: params.fund_name, instrument_id: params.instrument_id },
    }),
    getDaily: (params) => http.get('/v2/accrued-interests/daily', { params: scope(params) }),
    getBalances: (params) => http.get('/v2/accrued-interests/balances', { params: scope(params) }),
    adjustDaily: (params) => http.patch(`/v2/accrued-interests/daily/${encodeURIComponent(params.trade_id)}`, {
        body: { ...scope(params), amount: params.amount, notes: params.notes },
    }),
    confirmBalances: (params) => http.post('/v2/accrued-interests/balances/confirm', {
        body: {
            ...scope(params),
            rows: params.rows.map(({ trade_id, revision, override }) => ({
                trade_id,
                revision,
                ...(override
                    ? {
                        override: {
                            opening_balance_local: override.opening_balance_local,
                            accrued_balance_local: override.accrued_balance_local,
                            notes: override.notes,
                        },
                    }
                    : {}),
            })),
        },
    }),
}));
